import { SiteDirection } from "../../data";

const baseClass = "rj-superbanner";

export type SidePosition = "left" | "right";

export type Scrollability = {
    left: boolean;
    right: boolean;
};

export type GetBannerClassesProps = {
    scrollability: Scrollability;
    siteDir: SiteDirection;
    isMultipleItemsModeEnabled: boolean;
    draggability: boolean;
    isMobileMode: boolean;
};

export type GetBannerModifierProps = GetBannerClassesProps & {
    side: SidePosition;
};

function toUpperCase(str: string) {
    return str.toUpperCase();
}

function getSide(siteDir: SiteDirection, side: SidePosition) {
    return siteDir === SiteDirection.rightToLeft ?
        side === "left" ? "right" : "left" :
        side;
}

function getBannerModifier(props: GetBannerModifierProps) {
    let mod = getSide(props.siteDir, props.side).replace(/^(.)/g, toUpperCase);
    return props.scrollability[props.side] ? ` ${baseClass}--s${mod}` : "";
}

function getBannerModeModifier(props: GetBannerClassesProps) {
    return !props.isMultipleItemsModeEnabled ? ` ${baseClass}--desktop-full-view` : "";
}

function getBannerDragModifier(draggable: boolean) {
    return draggable ? ` ${baseClass}--draggable` : "";
}

function getMobileModeModifier(props: GetBannerClassesProps) {
    return props.isMobileMode ? ` ${baseClass}--mobile-small-view` : "";
}

export function getBannerClasses(props: GetBannerClassesProps) {
    let leftProps: GetBannerModifierProps = {
        ...props,
        side: "left"
    };
    let rightProps: GetBannerModifierProps = {
        ...props,
        side: "right",
    };
    return `${baseClass}${getBannerModeModifier(props)}` +
        `${getBannerModifier(leftProps)}${getBannerModifier(rightProps)}` +
        `${getBannerDragModifier(props.draggability)}${getMobileModeModifier(props)}`;
}